import { i18n } from "./main";

export const swalDiscardChangesConfig = {
	text: i18n.t("global.unsaved_changes_discard_them"),
	showCancelButton: true,
	focusCancel: true,
	reverseButtons: true,
	cancelButtonText: i18n.t("global.cancel"),
	confirmButtonText: i18n.t("global.discard"),
	customClass: "swal_dicard_modal",
};
